import { render, staticRenderFns } from "./suData2.vue?vue&type=template&id=76e2bf7c&scoped=true&"
import script from "./suData2.vue?vue&type=script&lang=js&"
export * from "./suData2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2bf7c",
  null
  
)

export default component.exports